import { render, staticRenderFns } from "./SearchStudent.vue?vue&type=template&id=ec8d6f2a&scoped=true"
import script from "./SearchStudent.vue?vue&type=script&lang=js"
export * from "./SearchStudent.vue?vue&type=script&lang=js"
import style0 from "./SearchStudent.vue?vue&type=style&index=0&id=ec8d6f2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8d6f2a",
  null
  
)

export default component.exports